import React from "react";
import { Link } from "react-router-dom";

import { buildBarcodeHistoryPath } from "../controls/TraceableBarcode";

type BarcodeHistoryLinkProps = {
  barcode: string | number | null | undefined;
  className?: string;
};

/** Inventory row action that opens barcode lifecycle history. */
export default function BarcodeHistoryLink({
  barcode,
  className = "",
}: BarcodeHistoryLinkProps) {
  if (barcode == null || String(barcode).trim() === "") return null;

  return (
    <Link
      to={buildBarcodeHistoryPath(barcode)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`View barcode history for ${barcode}`}
      className={`ml-2 inline-flex items-center rounded-md bg-sky-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 ${className}`.trim()}
    >
      History
    </Link>
  );
}
